const updateCapTable = capTable => ({
  type: 'UPDATE_CAP_TABLE',
  capTable,
});

export {
  updateCapTable,
};
